import { render, staticRenderFns } from "./Poblation.vue?vue&type=template&id=a9322a60&scoped=true"
import script from "./Poblation.vue?vue&type=script&lang=js"
export * from "./Poblation.vue?vue&type=script&lang=js"
import style0 from "./Poblation.vue?vue&type=style&index=0&id=a9322a60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9322a60",
  null
  
)

export default component.exports